import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum ToolboxPanelModeType {
  GEOGEBRA = 'geogebra',
  NOTES = 'notes',
  NONE = 'none',
  MANUAL = 'teachers-manual',
}

export enum ToolboxPanelTypes {
  GROUP_NOTES_LIST = 'group-notes-list',
  GEO_GEBRA_CALCULATOR = 'geo-gebra-calculator',
  FROALA_NOTES_EDITOR = 'froala-notes-editor',
  MANUAL = 'teachers-manual',
}

export type ToolboxPanelContent = {
  type: ToolboxPanelTypes | null;
  bookId?: string;
  pageId?: string;
  blockId?: string | null;
  readOnly?: boolean;
}
export interface TrajectoryToolboxState {
  toolboxPanelMode: ToolboxPanelModeType;
  toolboxPanelOpen: boolean;
  isToolboxPanelBlocked:  boolean;
  toolboxPanelVisible: boolean;
  toolboxPanelContent: ToolboxPanelContent | null;
  toolboxPanelHalfScreen: boolean;
  toolboxVisible: boolean;
}

const initialState: TrajectoryToolboxState = {
  toolboxPanelMode: ToolboxPanelModeType.NONE,
  isToolboxPanelBlocked: false,
  toolboxPanelOpen: false,
  toolboxPanelVisible: false,
  toolboxPanelContent: null,
  toolboxPanelHalfScreen: false,
  toolboxVisible: false,
};

const trajectoryToolboxSlice = createSlice({
  name: 'trajectoryToolbox',
  initialState,
  reducers: {
    setToolboxPanelMode(state, action: PayloadAction<ToolboxPanelModeType>) {
      state.toolboxPanelMode = action.payload;
    },
    setToolboxPanelOpen(state, action: PayloadAction<boolean>) {
      state.toolboxPanelOpen = action.payload;
    },
    setBlockToolboxPanel(state, action: PayloadAction<boolean>) {
      state.isToolboxPanelBlocked = action.payload;
    },
    setToolboxPanelVisible(state, action: PayloadAction<boolean>) {
      state.toolboxPanelVisible = action.payload;
    },
    setToolboxPanelContent(state, action: PayloadAction<ToolboxPanelContent>) {
      state.toolboxPanelContent = {...state.toolboxPanelContent , ...action.payload};
    },
    resetToolboxPanelContent(state) {
      state.toolboxPanelContent = initialState.toolboxPanelContent;
    },
    setToolboxPanelHalfScreen(state, action: PayloadAction<boolean>) {
      state.toolboxPanelHalfScreen = action.payload;
    },
    setToolboxVisible(state, action: PayloadAction<boolean>) {
      state.toolboxVisible = action.payload;
    },
    cleanPanel: () => initialState,
  },
});

export const {
  setToolboxPanelMode,
  setToolboxPanelOpen,
  setBlockToolboxPanel,
  setToolboxPanelVisible,
  setToolboxPanelContent,
  resetToolboxPanelContent,
  setToolboxPanelHalfScreen,
  setToolboxVisible,
  cleanPanel,
} = trajectoryToolboxSlice.actions;

export const { reducer: trajectoryToolboxReducer } = trajectoryToolboxSlice;
